module.exports = __webpack_public_path__ + "static/media/container7.9889c015.jpg";